// SG video banner (sections/sg-video-banner.liquid): load and play each looping video only while it is on screen,
// pause it when it scrolls away. The pause/play button next to each video wins: once a shopper pauses, the video
// stays paused until they press play. With reduced motion nothing autoplays; the button still plays the video.
// A video rendered with data-sg-user-paused="true" starts paused (story rows' "Start the video paused").
(function () {
  // once per page: several sections include this file (About: the top banner and the story rows), and a second copy's
  // click listener undid every tap (play, then pause at once)
  if (window.sgVideoBanner) return;
  window.sgVideoBanner = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var play = function (video) {
    showPoster(video);
    if (video.preload === 'none') video.preload = 'auto';
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  };

  var observer = !reduced && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting) {
        if (video.dataset.sgUserPaused !== 'true') play(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }, { rootMargin: '200px 0px' }) : null;

  // The poster frame waits until the banner is near the screen (sg-video-banner.liquid renders it as data-sg-poster):
  // a <video> poster always downloads with the page, ~90 KB competing with the hero on a slow connection
  var showPoster = function (video) {
    var poster = video.getAttribute('data-sg-poster');
    if (!poster) return;
    video.setAttribute('poster', poster);
    video.removeAttribute('data-sg-poster');
  };
  var posterObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      posterObserver.unobserve(entry.target);
      showPoster(entry.target);
    });
  }, { rootMargin: '800px 0px' }) : null;

  var syncButton = function (video) {
    var button = video.parentElement && video.parentElement.querySelector('[data-sg-vbanner-toggle]');
    if (!button) return;
    button.classList.toggle('is-paused', video.paused);
    button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
  };

  var init = function () {
    document.querySelectorAll('[data-sg-vbanner] video.sg-vbanner__video').forEach(function (video) {
      if (video.dataset.sgVbannerReady) return;
      video.dataset.sgVbannerReady = 'true';
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.addEventListener('play', function () { syncButton(video); });
      video.addEventListener('pause', function () { syncButton(video); });
      syncButton(video);
      if (posterObserver) posterObserver.observe(video); else showPoster(video);
      if (observer) observer.observe(video); else if (!reduced) play(video);
    });
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-sg-vbanner-toggle]');
    // a video marked data-sg-tap (story rows' "Start the video paused") also plays / pauses when the video is tapped
    var tapped = !button && event.target.closest && event.target.closest('video.sg-vbanner__video[data-sg-tap]');
    if (tapped) button = tapped.parentElement.querySelector('[data-sg-vbanner-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var video = button.parentElement.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.dataset.sgUserPaused = 'false';
      // a video that waited paused (a founder talking) plays with sound once the shopper asks for it
      if (video.hasAttribute('data-sg-sound-on-play')) video.muted = false;
      play(video);
    } else {
      video.dataset.sgUserPaused = 'true';
      video.pause();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
